import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/app/App'
import { AppProviders } from '@/app/AppProviders'
import { AppErrorBoundary } from '@/components'
import { initializeDevicePreferences } from '@/services/devicePreferences'
import { initializePwaInstallPromptCapture } from '@/services/pwaInstallService'
import '@/styles/index.css'

initializePwaInstallPromptCapture()
initializeDevicePreferences()

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Elemento raiz da aplicação não encontrado.')
}

createRoot(rootElement).render(
  <StrictMode>
    <AppErrorBoundary>
      <AppProviders>
        <App />
      </AppProviders>
    </AppErrorBoundary>
  </StrictMode>,
)
